import classNames from 'classnames';
import { Plus } from 'lucide-react';
import { Pages } from 'modules/navigation/domain/enums/pages';
import { clearSelectedChampionship } from 'modules/tournaments/store/championship/actions';
import UDButton from 'ud-ui/components/button';
import UDText from 'ud-ui/components/text';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

type Props = {
  className?: string;
};

const MainComponentsEmptyListMessage = (props: Props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleCreateTourneyClick = useCallback(() => {
    dispatch(clearSelectedChampionship());
    navigate(Pages.TOURNEYS.CREATE);
  }, [dispatch, navigate]);

  return (
    <div className={classNames('flex flex-col items-center', props.className)}>
      <UDText type="headline" className="mb-2">
        {t('championships.emptyList.title')}
      </UDText>
      <UDText type="body-text" className="mb-6">
        {t('championships.emptyList.body')}
      </UDText>
      <UDButton variant="dark" className="flex items-center flex flex-row" onClick={handleCreateTourneyClick}>
        {/* <UDColorableIcon
         name="plus"
         componentProps={{ className: 'mr-2 text-accentNaplesYellow' }}
         /> */}
        <Plus size={16} className="text-accentNaplesYellow mr-2" />
        {t('championships.createTournamentButtonTitle')}
      </UDButton>
    </div>
  );
};

export default MainComponentsEmptyListMessage;
